import FormControl from "@mui/material/FormControl";
import {InputLabel, MenuItem} from "@mui/material";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";

export const ScheduleSelect = ({ schedules, onChange, value }) => {
    const alwaysSchedule = schedules.find((s) => s.name === "Always");
    const neverSchedule = schedules.find((s) => s.name === "Never");
    const otherSchedules = schedules.filter(
        (s) => s.name !== "Always" && s.name !== "Never").sort((a, b) => a.name.localeCompare(b.name));

    return (

        <FormControl fullWidth>
            <InputLabel id="schedule-label">Hidden</InputLabel>
            <Select
                labelId="schedule-label"
                id="schedule"
                label="Hidden"
                value={value || ""}
                onChange={onChange}
            >
                {alwaysSchedule && (
                    <MenuItem key={alwaysSchedule.id} value={alwaysSchedule.id}>
                        {alwaysSchedule.name}
                    </MenuItem>
                )}
                {neverSchedule && (
                    <MenuItem key={neverSchedule.id} value={neverSchedule.id}>
                        {neverSchedule.name}
                    </MenuItem>
                )}
                {otherSchedules.map((schedule) => (
                    <MenuItem key={schedule.id} value={schedule.id}>
                        {schedule.name}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText>Hidden locations are not included in metric calculations</FormHelperText>
        </FormControl>
    )
}
